import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
import localeId from '@angular/common/locales/id';
import {
	ApplicationConfig,
	LOCALE_ID,
	inject,
	provideAppInitializer,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import {
	provideRouter,
	withComponentInputBinding,
	withInMemoryScrolling,
	withViewTransitions,
} from '@angular/router';
import { routes } from './app.routes';
import { TenantProfileService } from './core/services/tenant-profile.service';
import { ThemeService } from './core/services/theme.service';

// Diperlukan oleh CurrencyPipe/DatePipe dengan locale 'id'.
registerLocaleData(localeId);

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		provideBrowserGlobalErrorListeners(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withViewTransitions(),
			withInMemoryScrolling({
				scrollPositionRestoration: 'enabled',
				anchorScrolling: 'enabled',
			}),
		),
		provideClientHydration(withEventReplay()),
		provideHttpClient(withFetch()),
		// Muat identitas/kontak tenant sebelum render (SSR) → footer/header/contact siap.
		// provideClientHydration meng-cache GET ke TransferState → browser tak fetch ulang.
		// Sekaligus terapkan tema warna (primary/accent) ke CSS var saat SSR → tanpa kedip.
		provideAppInitializer(() => {
			const tp = inject(TenantProfileService);
			const theme = inject(ThemeService);
			return tp.load().then(() => {
				const t = tp.theme();
				theme.apply(t.primary, t.accent);
			});
		}),
		{ provide: LOCALE_ID, useValue: 'id' },
	],
};
